import { render, staticRenderFns } from "./SelectProjectModal.vue?vue&type=template&id=56de9fa1&"
import script from "./SelectProjectModal.vue?vue&type=script&lang=js&"
export * from "./SelectProjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56de9fa1')) {
      api.createRecord('56de9fa1', component.options)
    } else {
      api.reload('56de9fa1', component.options)
    }
    module.hot.accept("./SelectProjectModal.vue?vue&type=template&id=56de9fa1&", function () {
      api.rerender('56de9fa1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/accessmanagement/SelectProjectModal.vue"
export default component.exports